import service from "../utils/request";
const API_ENV = process.env.API_ENV; // dev or production

/**
 * 获取Sessions
 */
export function getSessions() {
    return service({
        url: "/session/list",
        method: "get",
    });
}

export function sendMessage(data) {
    return service({
        url: "/server/session/new_message",
        method: "post",
        data,
    });
}

/**
 * 获取Sessions-根据URL参数决定使用哪个接口
 * 如果URL包含?dev=true，则使用测试环境接口 /api/device/list/online
 * 否则使用正式环境接口 /server/device/list/online
 */
export function getSessionsList() {
    // 检查URL参数是否包含dev=true
    const urlParams = new URLSearchParams(window.location.search);
    const isDev = urlParams.get('dev') === 'true';
    const apiUrl = isDev ? "/api/device/list/online" : "/server/device/list/online";
    return service({
        url: apiUrl,
        method: "get",
    });
}